"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SearchSubmitButton;
exports.styles = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _Search = _interopRequireDefault(require("@material-ui/icons/Search"));

var _react = _interopRequireDefault(require("react"));

var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var styles = function styles(theme) {
  return {
    /**
     * Styles applied to the root element.
     */
    root: {},

    /**
     * Styles applied to the label element.
     */
    label: {
      display: 'flex'
    }
  };
};

exports.styles = styles;
var useStyles = (0, _makeStyles["default"])(styles, {
  name: 'RSFSearchSubmitButton'
});
/**
 * A button to submit the search.  All other props are spread to the provided `Component`.
 */

function SearchSubmitButton(_ref) {
  _ref = Object.assign({}, {
  ButtonIcon: _Search["default"]
}, _ref);
  var Component = _ref.Component,
      ButtonIcon = _ref.ButtonIcon,
      classes = _ref.classes,
      text = _ref.text,
      others = (0, _objectWithoutProperties2["default"])(_ref, ["Component", "ButtonIcon", "classes", "text"]);
  classes = useStyles({
    classes: classes
  });
  return /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({
    rel: "search",
    type: "submit",
    className: classes.root,
    classes: {
      label: classes.label
    },
    disabled: text.trim().length === 0
  }, others), /*#__PURE__*/_react["default"].createElement(ButtonIcon, null));
}

SearchSubmitButton.propTypes = {
  /**
   * Override or extend the styles applied to the component. See [CSS API](#css) below for more details.
   */
  classes: _propTypes["default"].object,

  /**
   * A Material UI button component to display.
   */
  Component: _propTypes["default"].elementType.isRequired,

  /**
   * A Material UI button component to display.
   */
  ButtonIcon: _propTypes["default"].elementType,

  /**
   * The current search text.
   */
  text: _propTypes["default"].string.isRequired
};
